import { TCaseMemberIdCheckForm } from "../../../domain/codecs/form/CaseMemberForm";

export const idCheckUpdateShouldAutosave = (edited: TCaseMemberIdCheckForm["edited"]): boolean =>
    !(edited.id_check_result_identity_document_status === "manual_pass"
        && edited.manual_pass_reason.trim() === "");
